/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {QrCode} from "@mui/icons-material";
import IngresoTextoClaro from "../../Modulo_formularios/Componentes/IngresoTextoClaro";

const Formulario_Registro = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTextoClaro Icono={QrCode} nombre={'Código'} dato={'codigo'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Registro